import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Tabs from "./components/Tabs/Tabs";
import OverviewTab from "./components/OverviewTab/OverviewTab";
import ExpensesTab from "./components/ExpensesTab/ExpensesTab";
import RevenueTab from "./components/Revenue/RevenueTab";
import styles from "./Accounting.module.css";
import { OverviewIcon, ExpensesIcon, RevenueIcon } from "../../Component/Shared/Icon/Icon";

const TABS = [
  { key: "overview", label: "نظرة عامة", icon: <OverviewIcon /> },
  { key: "expenses", label: "المصروفات", icon: <ExpensesIcon /> },
  { key: "revenue", label: "الإيرادات", icon: <RevenueIcon /> },
];

const Accounting = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderTab = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewTab />;
      case "expenses":
        return <ExpensesTab />;
      case "revenue":
        return <RevenueTab />;
      default:
        return null;
    }
  };

  return (
    <div className="apDiv ChatApp">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>

        <div className={styles.pageContent}>
          <Tabs tabs={TABS} activeTab={activeTab} onChange={setActiveTab} />
          {renderTab()}
        </div>
      </div>
    </div>
  );
};

export default Accounting;